export default {"src":"/_next/static/media/bonus-track-unavailable.6b6116b3.gif","height":110,"width":110,"blurWidth":0,"blurHeight":0};